import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'How long does the trademark registration process take?',
      answer: 'The entire process typically takes 8-12 months from filing to registration. This includes the initial filing, USPTO examination period, publication for opposition, and final registration. We keep you updated throughout every step.'
    },
    {
      question: 'What is the difference between ™ and ® symbols?',
      answer: 'The ™ symbol can be used immediately when you claim trademark rights, even before registration. The ® symbol can only be used after your trademark is officially registered with the USPTO. Using ® before registration is illegal and can result in penalties.'
    },
    {
      question: 'Do I need a trademark attorney?',
      answer: "While it's not legally required, using an attorney significantly increases your chances of approval. Our attorneys ensure proper classification, craft compelling descriptions, and handle office actions that could otherwise result in rejection."
    },
    {
      question: 'What if my trademark application is rejected?',
      answer: 'If your application receives an office action (rejection or objection), our attorneys will review it and prepare a comprehensive response at no additional cost in our Professional and Enterprise plans. We have extensive experience overcoming USPTO objections.'
    },
    {
      question: 'Can I trademark a business name that is already a domain?',
      answer: 'Owning a domain name does not automatically give you trademark rights. Trademark protection is separate and more comprehensive. Even if the domain is available, the trademark might not be, which is why our comprehensive search is crucial.'
    },
    {
      question: 'What classes should I file under?',
      answer: 'Trademarks are filed under specific classes based on the goods or services you offer. Our team will help you select the appropriate classes during the application process. Most businesses need 1-3 classes, but some require more for comprehensive protection.'
    },
    {
      question: 'Do you offer international trademark registration?',
      answer: 'Yes! We can help you file international trademarks through the Madrid Protocol, which allows you to protect your trademark in over 120 countries with a single application. Contact us for a custom quote for international filing.'
    },
    {
      question: 'What happens after my trademark is registered?',
      answer: 'After registration, you must maintain your trademark by filing maintenance documents between the 5th-6th year and 9th-10th year, then renewing every 10 years. Our monitoring service also watches for potential infringers and alerts you to protect your rights.'
    }
  ];

  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-gray-600">
            Everything you need to know about trademark registration
          </p>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-100 transition-colors"
              >
                <span className="text-left font-semibold text-black pr-8 text-sm">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-[#FF035B] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-6 pb-4 text-gray-700 leading-relaxed text-sm">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;